export const blockIconsPlacesCottage = (
	<span className='material-symbols-outlined'>cottage</span>
);
